import React from 'react';
/**
 * Renders a three-row layout where one row can take the full available height.
 * Each row can be optionally scrollable. Grid layout is used for structure.
 *
 * @param {LayoutRows3Props} props - Props for configuring the three-row layout.
 * @param {React.ReactNode} [props.row1] - Optional content for the first row.
 * @param {React.ReactNode} [props.row2] - Optional content for the second row.
 * @param {React.ReactNode} [props.row3] - Optional content for the third row.
 * @param {'row1' | 'row2' | 'row3'} props.fullHeightRow - Specifies which row takes up the remaining vertical space.
 * @param {boolean} [props.row1Scrollable] - Enables scrolling for the first row if true.
 * @param {boolean} [props.row2Scrollable] - Enables scrolling for the second row if true.
 * @param {boolean} [props.row3Scrollable] - Enables scrolling for the third row if true.
 * @param {string} [props.data-test] - Optional test ID for the outer container.
 * @returns {JSX.Element} A responsive layout with three vertically stacked rows.
 */
export const LayoutRows3 = (props) => {
    const fhr = props.fullHeightRow;
    return (React.createElement("div", { style: {
            display: 'grid',
            width: '100%',
            height: '100%',
            gridTemplateRows: size(fhr === 'row1') + ' ' + size(fhr === 'row2') + ' ' + size(fhr === 'row3'),
            gridTemplateColumns: '100%',
        }, "data-test": props['data-test'] },
        React.createElement("div", { style: { overflow: props.row1Scrollable ? 'auto' : fhr === 'row1' ? 'hidden' : undefined, gridRow: '1/2' }, "data-test": 'row1' }, props.row1 && props.row1),
        React.createElement("div", { style: { overflow: props.row2Scrollable ? 'auto' : fhr === 'row2' ? 'hidden' : undefined, gridRow: '2/3' }, "data-test": 'row2' }, props.row2 && props.row2),
        React.createElement("div", { style: { overflow: props.row3Scrollable ? 'auto' : fhr === 'row3' ? 'hidden' : undefined, gridRow: '3/4' }, "data-test": 'row3' }, props.row3 && props.row3)));
};
function size(full) {
    return full ? '1fr' : 'auto';
}
